import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const FilterComponentWrapper = styled.div`
    background: #ffff;
    margin: 5px 16px;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
`;

export const FilterComponentHeaderFooter = styled.div`
    background: #ffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 28px;
    padding-right: 19px;
    padding-top: 18px;
    padding-bottom: 20px;
    border-radius: 6px;
    align-items: center;
    cursor: pointer;
`;
export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: ${(props) => props.color};
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
    font-size: 15px;
`;
export const TextRegular = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    color: ${(props) => props.color};
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;

export const FilterSetDefaultButton = styled.button`
    width: 100%;
    height: 38px;
    background: ${(props) =>
        props.hasDefaultViewChanged ? '#1010EB' : '#3c3c3c'};
    border-radius: 5px;
    display: flex;
    justify-content: center;
    border: none;
    &:hover {
        cursor: pointer;
    }
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 1px solid #eee;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
`;

export const SearchBoxContainer = styled.div`
    width: 100%;
    margin: 0;
    display: 'flex';
    justify-content: space-between;
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    color: #140f4b;
    align-items: center;
    ${media.mobileDevice`
        padding: 0px 17px 10px 25px;
    `};

    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        right: 19%;
        // @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation : portrait) {
        //     right: 12%;
        // }
        // @media only screen and (max-device-width: 490px) and (orientation : portrait) {
        //     right: 2.25rem !important;
        //     padding-right:15px;
        //     }
    }

    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        // right: 12%;
    }
`;
